export default "__VITE_ASSET__BteD7Ym5__"